import * as THREE from 'three'
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import store from '../store/index'
// , position, rotation
// eslint-disable-next-line no-unused-vars
import * as cc from 'my-design-canvas/desf4fc'
import { Scenes } from './threeScene'
// eslint-disable-next-line no-unused-vars
// 平铺材质
// import * as Nodes from 'three/examples/jsm/nodes/Nodes.js'
// import { makeNolmalMapReal } from './util'
// function clearCache(scene, renderer) {
//     scene.remove()
//     renderer.dispose()
//     renderer.forceContextLoss()
//     renderer.content = null
//     renderer.domElement = null
// }
// eslint-disable-next-line no-unused-vars
async function mergeColorAndUserDesign(view_id, color_image_src) {
  var { fabricList, print_areas } = store.state.design
  const activeFabric = fabricList.find(item => item.view_id === view_id)

  // const { color_image_src } = items.find(item => item.view_id === view_id)
  const ca = document.createElement('canvas')
  ca.height = 550 * 2
  ca.width = 550 * 2
  const caObj = new cc.StaticCanvas(ca, {})
  // eslint-disable-next-line promise/param-names
  await new Promise(res => {
    cc.Image.fromURL(
      color_image_src,
      function(img) {
        img.scale((550 * 2) / 469)
        caObj.add(img)
        res()
      },
      { crossOrigin: 'anonymous' }
    )
  })
  if (activeFabric) {
    let { left, top, height, width } = print_areas.find(item => item.view_id === view_id)
    left = parseInt(left)
    top = parseInt(top)
    height = parseInt(height)
    width = parseInt(width)
    const designZoom = store.state.design.zoom
    const userDesign = activeFabric.canObj.toDataURL({
      multiplier: designZoom * 2,
      left: left / designZoom,
      top: top / designZoom,
      height: height / designZoom,
      width: width / designZoom
    })

    const scale = 2
    // eslint-disable-next-line promise/param-names
    await new Promise(res => {
      cc.Image.fromURL(
        userDesign,
        function(img) {
          img.set({
            left: left * scale,
            top: top * scale
            // scaleX: scale,
            // scaleY: scale
          })

          caObj.add(img)
          res()
        },
        { crossOrigin: 'anonymous' }
      )
    })
  }
  return caObj.toDataURL()
}
const renderer = new THREE.WebGLRenderer({
  antialias: true,
  alpha: true,
  preserveDrawingBuffer: true
})
renderer.setSize(1200, 1200)
const textureLoader = new THREE.TextureLoader()
export async function threeRenderMain({ image_src, design_params, items, normal_image_info, light_params }, index) {
  if (Scenes[index]) {
    const { scene, camera } = Scenes[index]
    for (let i = 0; i < items.length; i++) {
      const { view_id, color_image_src } = items[i]
      const mesh = scene.getObjectByName('view_id_' + view_id)
      const userDesign = await mergeColorAndUserDesign(view_id, color_image_src)
      // eslint-disable-next-line promise/param-names
      await new Promise(res => {
        textureLoader.load(userDesign, map => {
          map.flipY = false
          // map.wrapS = map.wrapT = THREE.RepeatWrapping
          mesh.material.map = map
          // mesh.material.map = new Nodes.TextureNode(map)
          // mesh.material.needsUpdate = true
          res()
          // renderer.dispose()
        })
      })
    }
    renderer.render(scene, camera)
    return renderer.domElement.toDataURL()
    // const mesh = scene.getObjectByName('view_id_' + activeDesign)
    // const userDesign = await mergeColorAndUserDesign(
    //   activeDesign,
    //   items.find(item => item.view_id === activeDesign).color_image_src
    // )
    // // eslint-disable-next-line promise/param-names
    // return new Promise(res => {
    //   textureLoader.load(userDesign, map => {
    //     map.flipY = false
    //     // map.wrapS = map.wrapT = THREE.RepeatWrapping
    //     mesh.material.map = map
    //     // mesh.material.map = new Nodes.TextureNode(map)
    //     // mesh.material.needsUpdate = true
    //     renderer.render(scene, camera)
    //     res(renderer.domElement.toDataURL())
    //     // renderer.dispose()
    //   })
    // })
  } else {
    // eslint-disable-next-line no-unused-vars
    // zoom,
    const { loader } = store.state.threeLoader
    const scene = new THREE.Scene()
    // eslint-disable-next-line promise/param-names
    return new Promise(res => {
      loader.load(image_src, async obj => {
        scene.add(obj.scene)
        const camera = obj.cameras[0]
        const ambientLight = new THREE.AmbientLight(0xffffff, light_params.ambient)
        scene.add(ambientLight)
        const directional = new THREE.DirectionalLight(0xffffff, light_params.directional)
        directional.position.copy(camera.position)
        scene.add(directional)
        await Promise.all(
          items.map(async item => {
            const { color_image_src, view_id } = item
            const mesh = scene.getObjectByName('view_id_' + view_id)
            const { normal_image_src } = normal_image_info.find(normal_image => normal_image.view_id === view_id)
            const userDesign = await mergeColorAndUserDesign(view_id, color_image_src)
            // eslint-disable-next-line promise/param-names
            return new Promise(res => {
              textureLoader.load(normal_image_src, normalMap => {
                textureLoader.load(userDesign, map => {
                  map.flipY = false
                  normalMap.flipY = false
                  const material = new THREE.MeshStandardMaterial({
                    normalMap,
                    map,
                    roughness: light_params.roughness
                  })
                  // 平铺代码
                  // normalMap.wrapS = normalMap.wrapT = THREE.RepeatWrapping
                  // map.wrapS = map.wrapT = THREE.RepeatWrapping
                  // // // console.log(Nodes)
                  // const material = new Nodes.MeshStandardNodeMaterial()
                  // material.roughness = 0.9
                  // // material.metalness = 0.5
                  // material.map = new Nodes.TextureNode(map)
                  // const normal = new Nodes.TextureNode(normalMap)
                  // normal.uv = new Nodes.UVTransformNode()
                  // normal.uv.setUvTransform(0, 0, 3, 3, 0)
                  // material.normalMap = normal
                  // // const normal = normalMap
                  // // console.log(normalMap)
                  // console.log(Nodes.MeshStandardNodeMaterial)

                  // material.normalMap = normal
                  // console.log(material)
                  mesh.material = material
                  // console.log(mesh)
                  res()
                })
              })
            })
          })
        )
        renderer.render(scene, camera)
        res(renderer.domElement.toDataURL())
        // renderer.dispose()
        Scenes[index] = {
          scene,
          camera
        }
        // store.commit('SET_THREE_SCENE', { index, data: scene })
      })
    })
  }
}
